import { memo, useEffect, useState } from "react";
import deviceProfile from "images/device.png";
import dayjs from "dayjs";
import { utcToLocal } from "js/helpers/date";
import { fetchResultDetails } from "js/Api/forms";
import { FaChevronRight } from "react-icons/fa";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";

/**
 * The ResponsesList component renders a table displaying a list of responses with a question and
 * answer for each item.
 * @param props - The `ResponsesList` component receives a `props` object as a parameter. The `props`
 * object may contain a property `responsesList` which is an array of responses. If the `responsesList`
 * property is not provided in the `props` object, it defaults to an array `[1
 * @returns The `ResponsesList` component is being returned. It is a functional component that displays
 * a list of responses in a table format. The responses are hardcoded in the component as "Car, Bike,
 * Bus, Walk" for the question "What is your preferred mode of transport?". The component also includes
 * the name of a user (Judy Baker) and an image placeholder.
 */
const ResponsesList = (props) => {
    const { selectedResponse, handleBackClick, Parent } = props;
    const [resultResponse, setresultResponse] = useState([]);
    const [resultResponseSub, setresultResponseSub] = useState([]);

    const fetchResultDetailHandler = async () => {
        if (selectedResponse?.id) {
            const response = await fetchResultDetails(selectedResponse?.id);
            if (response?.success && response?.data) {
                const sortedArrayBasedOnFieldOrder = response?.data.filter(a => a.refFieldOption === null).sort?.((a, b) => a.fieldOrder - b.fieldOrder);
                setresultResponse(sortedArrayBasedOnFieldOrder);

                const sortedArrayBasedOnFieldOrder_Sub = response?.data.filter(a => a.refFieldOption !== null).sort?.((a, b) => a.fieldOrder - b.fieldOrder);
                setresultResponseSub(sortedArrayBasedOnFieldOrder_Sub);
            }
        }
    };

    useEffect(() => {
        fetchResultDetailHandler();
    }, [selectedResponse]);

    const BindAnswers = ({ answers }) => {
        return (
            <>
                {answers !== null && answers?.length > 0 ?
                    <>
                        {answers.map((g) => g.fieldOption).join(", ")}
                    </> : ""
                }
            </>
        );
    }

    const FindSubQue = ({ answers, formFieldOptionId }) => {
        const subQues = resultResponseSub.filter(a => formFieldOptionId.includes(a.refFieldOption));

        return (
            <>
                {subQues.length === 1 &&
                    <>
                        <tr>
                            <td style={{ borderBottom: "0px" }}>
                                <span style={{ marginLeft: "20px" }}>{answers.find(m => m.id === subQues[0].refFieldOption).fieldOption}</span>
                            </td>
                            <td style={{ borderBottom: "0px" }}>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ borderTop: "0px" }}>
                                <span style={{ marginLeft: "20px" }}><FaChevronRight />  {subQues[0].fieldName}</span>
                            </td>
                            <td style={{ borderTop: "0px" }}>
                                {subQues[0].freeTextResponse} <BindAnswers answers={subQues[0].answers} />
                            </td>
                        </tr>
                    </>
                }
            </>
        );
    }

    return (
        <div className="table-wrap padding_infor_info">
            <div className="form-group">

                <div class="user-container">
                    <ArrowBackRoundedIcon
                        onClick={handleBackClick}
                        sx={{
                            fontSize: "2rem",
                            color: "black",
                            marginRight: "10px",
                            cursor: "pointer",
                        }}
                    />
                    {Parent === "device-list" ? null : <>
                        {selectedResponse.profilePicture ? (
                            <img className="user-photo" src={`data:image/png;base64, ${selectedResponse.profilePicture}`} alt={selectedResponse.name} />
                        ) : (
                            <img className="user-photo" src={deviceProfile} alt="Default profile" />
                        )}
                        <span class="user-name">{selectedResponse?.name}</span>
                    </>
                    }
                </div>
                <br />

                <div>
                    <p>
                        <span class="user-name">{selectedResponse.formName}</span>
                    </p>
                    <p>
                        <span class="user-name">Answered on : {dayjs(utcToLocal(selectedResponse?.createdAt)).format("DD/MM/YYYY h:mma")}</span>
                    </p>

                    {/*<div style={{ float: "right" }}>*/}
                    {/*    <button class="export-btn">*/}
                    {/*        Export <span class="arrow">&#9662;</span>*/}
                    {/*    </button>*/}
                    {/*</div>*/}
                </div>
                <table className="table table-hover margin_top_30">
                    <thead>
                        <tr>
                            <th>Question</th>
                            <th>Answer</th>
                        </tr>
                    </thead>
                    <tbody>
                        {resultResponse?.length > 0 && (
                            resultResponse?.map?.((item, index) => (
                                <>
                                    <tr key={`item-${index}`}>
                                        <td>
                                            {item.fieldName}
                                        </td>
                                        <td>
                                            {item.freeTextResponse}  <BindAnswers answers={item.answers} />
                                        </td>
                                    </tr>
                                    {item?.formFieldOptionId?.length > 0 &&
                                        item?.formFieldOptionId.map?.((item_sub, index_sub) => (
                                            <>
                                                <FindSubQue answers={item.answers} formFieldOptionId={item_sub} />
                                            </>
                                        ))
                                    }
                                </>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default memo(ResponsesList);
